import { render } from 'preact';
import { App } from './app/App';
import './styles/global.css';

const root = document.querySelector('#app');

if (!(root instanceof HTMLElement)) {
  throw new Error('Application root was not found.');
}

render(<App />, root);
